<template>
  <alarm-history />
</template>

<script>
import AlarmHistory from "./AlarmHistory.vue";
export default {
  components: { AlarmHistory },
  name: "AlarmsDetails",
};
</script>

<style></style>
